<template>
    <span class="position-relative">
        <span
            ref="labelelement"
            v-if="label !== ''"
            class="badge text-white position-absolute display-6 fw-light"
            :style="{
                bottom: `${index * (1.6 * (computedFontsize ?? 9)) + (computedFontsize ?? 9) * 1.4}px`,
                padding: '.25em .5em',
                'background-color': props.color,
                'border-color': createDarkerColor(props.color, 60),
                'font-size': computedFontsize + 'px',
            }"
            >{{ label }}</span
        >

        <svg
            v-if="props.type === 'pin'"
            width="21"
            height="37"
            viewBox="0 0 21 37"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="100%"
                    id="a"
                >
                    <stop
                        stop-color="#FB7468"
                        offset="0%"
                    />
                    <stop
                        stop-color="#E8443C"
                        offset="100%"
                    />
                </linearGradient>
                <path
                    d="M10.5 36.572c2.533-7.505 4.434-12.633 5.704-15.384C18.11 17.062 21 15.103 21 10.571 21 4.733 16.299 0 10.5 0S0 4.733 0 10.571c0 4.621 2.658 6.493 4.66 10.617 1.333 2.75 3.28 7.878 5.84 15.384z"
                    id="b"
                />
            </defs>
            <g
                fill="none"
                fill-rule="evenodd"
            >
                <use
                    fill="url(#a)"
                    xlink:href="#b"
                />
                <path
                    stroke-opacity=".243"
                    stroke="#000"
                    d="M10.497 35.023c2.305-6.769 4.054-11.447 5.253-14.044.44-.952.937-1.82 1.615-2.867.164-.254 1.044-1.578 1.278-1.946 1.304-2.047 1.857-3.55 1.857-5.595C20.5 5.008 16.022.5 10.5.5S.5 5.008.5 10.571c0 2.134.534 3.672 1.784 5.696.242.392 1.29 2 1.558 2.432A24.38 24.38 0 0 1 5.11 20.97c1.261 2.6 3.056 7.28 5.388 14.053z"
                />
                <ellipse
                    fill-opacity=".54"
                    fill="#000"
                    cx="10.5"
                    cy="10.571"
                    rx="3.78"
                    ry="3.806"
                />
            </g>
        </svg>

        <svg
            v-else
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                v-if="props.type === 'circle'"
                :r="props.width / 2"
                cx="10"
                cy="10"
                :fill="props.color"
                :stroke="strokecolor"
                stroke-width="1"
                :opacity="opacity"
            />
            <rect
                v-else-if="props.type === 'square'"
                :width="props.width"
                :height="props.height"
                :x="12 - props.width / 2"
                :y="12 - props.height / 2"
                :fill="props.color"
                :stroke="strokecolor"
                stroke-width="1"
                :opacity="opacity"
            />
        </svg>
    </span>
</template>
<script lang="ts" setup>
import { createDarkerColor } from '@/utilities/colorUtils';
import type { MapMarkerType } from './MapMarker';
import { computed, ref } from 'vue';

const props = withDefaults(
    defineProps<{
        color: string;

        type: MapMarkerType;

        height: number;

        width: number;

        index: number;

        strokecolor: string;

        label: string;

        opacity: number;

        /**
         * Increase or decrease the font size of the label
         * @default 1
         */
        fontfactor?: number;
    }>(),
    {
        fontfactor: 1,
    },
);

const labelelement = ref<HTMLSpanElement | null>(null);

// We save the original font size so we can calculate the new font size
let originalFontSize: number | null = null;

const computedFontsize = computed(() => {
    if (labelelement.value === null) {
        return null;
    }

    if (originalFontSize === null) {
        originalFontSize = parseFloat(getComputedStyle(labelelement.value).fontSize);
    }

    return originalFontSize * props.fontfactor;
});
</script>
